module.exports = __webpack_public_path__ + "media/images/home/river-5e6301409516b65f5d8b705bc6067b43.jpg";